<template>
	<div class="timed-activities padded">
		<div class="timed-activity">
			<div class="ta-date">
				<span>21st Jan, 2017</span>
			</div>
			<div class="ta-record-w">
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>11:55</strong> am
					</div>
					<div class="ta-activity">
						Created a post called <a href="#">Register new symbol</a> in Rogue
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>2:34</strong> pm
					</div>
					<div class="ta-activity">
						Commented on story <a href="#">How to be a leader</a> in <a href="#">Financial</a> category
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>7:12</strong> pm
					</div>
					<div class="ta-activity">
						Added <a href="#">John Silver</a> as a friend
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>9:39</strong> pm
					</div>
					<div class="ta-activity">
						Started following user <a href="#">Ben Mosley</a>
					</div>
				</div>
			</div>
		</div>
		<div class="timed-activity">
			<div class="ta-date">
				<span>3rd Feb, 2017</span>
			</div>
			<div class="ta-record-w">
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>9:32</strong> pm
					</div>
					<div class="ta-activity">
						Added <a href="#">John Silver</a> as a friend
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>5:14</strong> pm
					</div>
					<div class="ta-activity">
						Commented on story <a href="#">How to be a leader</a> in <a href="#">Financial</a> category
					</div>
				</div>
			</div>
		</div>
		<div class="timed-activity">
			<div class="ta-date">
				<span>21st Jan, 2017</span>
			</div>
			<div class="ta-record-w">
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>11:55</strong> am
					</div>
					<div class="ta-activity">
						Created a post called <a href="#">Register new symbol</a> in Rogue
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>2:34</strong> pm
					</div>
					<div class="ta-activity">
						Commented on story <a href="#">How to be a leader</a> in <a href="#">Financial</a> category
					</div>
				</div>
				<div class="ta-record">
					<div class="ta-timestamp">
						<strong>9:39</strong> pm
					</div>
					<div class="ta-activity">
						Started following user <a href="#">Ben Mosley</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        name: 'userActions',
        data () {
            return {
                actions: null,
            }
        },
        props: {
            userid: {
                Default: ''
            }
        },
	    mounted () {
            this.fetchActions();
	    },
	    methods: {
            async fetchActions () {

                this.$http.get(api+'api/v1/user/'+this.userid.uid+'/actions')
                    .then(response => {



                        this.actions = response.body.result.action;
                    }, response => {

                })
            },
	    }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/actions.vue